import { icon } from "leaflet";
import MarkerClusterGroup from "react-leaflet-cluster"; // Nueva versión
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CIcon } from '@coreui/icons-react';
import axios from 'axios';
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { useMapEvents } from 'react-leaflet/hooks';
import "leaflet/dist/leaflet.css";
import '../../index.css';
import Widgets from '../widgets/Widgets';
import * as XLSX from 'xlsx';
import Tooltip from "../Tooltip/tooltip";

import {
  CCard,
  CButton,
  CTab,
  CTabs,
  CTabList,
  CTabContent,
  CTabPanel,
  CFormInput,
  CFormLabel,
  CCol,
  CRow,
  CCardBody,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormSelect,
  CModalContent,
  CTooltip,
  CFormTextarea,
  CToast,
  CToastBody,
  CToastClose,
  CSpinner,
  CAlertLink,
  CCardImage,
  CPagination,
  CPaginationItem,
} from '@coreui/react';

import {
  cilMagnifyingGlass,
  cilMap,
  cilOptions,
  cilCloudDownload,
  cilCompress,
} from '@coreui/icons'

// import marketIcon from '../../assets/brand/turn-left.png';
import iconArrowDown from '../../assets/images/arrow-down.png'
import marketArbol from '../../assets/brand/arbol.png';
import marketAlumbrado from '../../assets/brand/alumbrado.png';
import marketSemaforo from '../../assets/brand/semaforo.png';
import marketBasura from '../../assets/brand/basura.png';
import marketBaches from '../../assets/brand/baches.png';
import marketMapaSeñal from '../../assets/brand/mapa-señal.png';
import circle from '../../assets/images/circle.png';
import circleVerde from '../../assets/images/circle-verde.png';
import circleVioleta from '../../assets/images/circle-violeta.png';
import circleNaranja from '../../assets/images/circle-naranja.png';
import circleAmarillo from '../../assets/images/circle-amarillo.png';
import copiar from '../../assets/brand/copia.png';
import copiadoImg from '../../assets/brand/copiado.png';
import locationIcon from '../../assets/brand/location.png';
import dataFrame from '../../assets/brand/data-frame.png';
import BuscadorSenales from './BuscadorSenales';

// Crea los iconos con los colores personalizados
const OrangeIcon = new icon({
  iconUrl: circleNaranja,
  iconSize: [14, 14],
  iconAnchor: [8, 8], // Centra el icono
  popupAnchor: [0, -8], // Ajusta el popup
});

const greenIcon = new icon({
  iconUrl: circleVerde,
  iconSize: [14, 14],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

const redIcon = new icon({
  iconUrl: circle,
  iconSize: [25, 25],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

const yellowIcon = new icon({
  iconUrl: circleAmarillo,
  iconSize: [14, 14],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

const VioletIcon = new icon({
  iconUrl: circleVioleta,
  iconSize: [14, 14],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

// Función para seleccionar el icono según el tipo de marcador
const getIcon = (type) => {
  switch (type) {
    case "arbol":
      return greenIcon;

    case "alumbrado":
      return OrangeIcon;

    case "basura":
      return VioletIcon;

    case "semaforo":
      return yellowIcon;

    case "bache":
      return redIcon;

    default:
      return greenIcon; // Rojo por defecto
  }
};

export default function DetailIndex({ profile, setProfile }) {

  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [visible3, setVisible3] = useState(false);
  const [frameData, setFrameData] = useState(null);
  const [tipoPrincipal , setTipoPrincipal] = useState(null);
  const [ubicacionEspecial, setUbicacionEspecial] = useState(null);
  const [enCalzada, setEnCalzada] = useState(null);
  const [obstruccionCalzada, setObstruccionCalzada] = useState(null);
  const [monticuloTamano, setMonticuloTamano] = useState(null);
  const [estimacionBolsasCant, setEstimacionBolsasCant] = useState(null);
  const [bolsasRotasDispersion, setBolsasRotasDispersion] = useState(null);
  const [acumulacion, setAcumulacion] = useState(null);
  const [animalMuerto, setAnimalMuerto] = useState(null);
  const [bolsas, setBolsas] = useState(null);
  const [escombro, setEscombro] = useState(null);
  const [neumatico, setNeumatico] = useState(null);
  const [poda, setPoda] = useState(null);
  const [voluminoso, setVoluminoso] = useState(null);
  const [observacionesjs, setObservacionesjs] = useState(null);  
  const [visibleDataFrame, setVisibleDataFrame] = useState(false);
  const [visibleDataFramePoda, setVisibleDataFramePoda] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [nameProyectoDetalles, setNameProyectoDetalles] = useState(null);
  const [senaleticaReclasificada, setSenaleticaReclasificada] = useState(null);
  const [descripcionReclasificada, setDescripcionReclasificada] = useState(null);
  const [severidadReclasificada, setSeveridadReclasificada] = useState(null);
  const [itemIdSenal, setItemIdSenal] = useState(null);
  const [tipoSenal, setTipoSenal] = useState(null);
  const [senaleticaDetectada, setSenaleticaDetectada] = useState(null);
  const [descripcionDetectada, setDescripcionDetectada] = useState(null);
  const [observacionesSenal, setObservacionesSenal] = useState(null);
  const [latitudSenal, setLatitudSenal] = useState(null);
  const [longitudSenal, setLongitudSenal] = useState(null);
  const [videoAsociadoSenal, setVideoAsociadoSenal] = useState(null);
  const [fechaDeteccionSenal, setFechaDeteccionSenal] = useState(null);
  const [puntokmSenal, setPuntokmSenal] = useState(null);
  const [sentidoSenal, setSentidoSenal] = useState(null);
  const [itemIdDano, setItemIdDano] = useState(null);
  const [tipoDano, setTipoDano] = useState(null);
  const [area, setArea] = useState(null);
  const [severidad, setSeveridad] = useState(null);
  const [observaciones, setObservaciones] = useState(null);
  const [latitudDano, setLatitudDano] = useState(null);
  const [longitudDano, setLongitudDano] = useState(null);
  const [carreteraAsociadaDano, setCarreteraAsociadaDano] = useState(null);
  const [fechaDeteccionDano, setfechaDeteccionDano] = useState(null);
  const [PuntokmDano, setPuntokmDano] = useState(null);
  const [sentidoDano, setsentidoDano] = useState(null);
  const [nombreProyecto1, setNombreProyecto1] = useState(null);
  const [fechaCreacion1, setFechaCreacion1] = useState(null);
  const [fechaInicio1, setFechaInicio1] = useState(null);
  const [fechaFin1, setFechaFin1] = useState(null);
  const [cliente1, setCliente1] = useState(null);
  const [operador1, setOperador1] = useState(null);
  const [descripcion1, setDescripcion1] = useState(null);
  const [clase, setClase] = useState(null);
  const [activeKey, setActiveKey] = useState(1); // Estado para el tab activo
  const [buscarTexto, setBuscarTexto] = useState(''); // Un único estado de búsqueda
  // Entrada temporal para el buscador; la búsqueda real se activa con el botón
  const [searchInput, setSearchInput] = useState('');
  const [claseSeleccionada, setClaseSeleccionada] = useState(''); // Estado para el menú desplegable de clase
  const [copiedRow, setCopiedRow] = useState(null); // Para indicar fila copiada temporalmente
  const [dataProyecto, setDataProyecto] = useState(null);
  const [idProyecto, setidProyecto] = useState(null);
  const [urlFrame, setUrlFrame] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [markersData, setMarkersData] = useState([]);
  const [mapFilter, setMapFilter] = useState('all'); // 'all' | 'vertical' | 'horizontal' | 'baches'
  const [data, setData] = useState([]);
  const [dataResults, setDataResults] = useState([]);
  const [dataResults2, setDataResults2] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageFisuras, setCurrentPageFisuras] = useState(0);
  const [currentPageSenales, setCurrentPageSenales] = useState(1); // Página actual para señales (empieza en 1)
  const [itemsPerPage, setItemsPerPage] = useState(50); // O la cantidad que desees
  const [itemsPerPageFisuras, setItemsPerPageFisuras] = useState(50); // O la cantidad que desees
  const navigate = useNavigate();
  const tableRef = useRef(null); // Referencia para la tabla
  const mapRef = useRef(null);
  const { id } = useParams();
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsFisuras, setCurrentItemsFisuras] = useState([]);
  const [totalPages, setTotalPages] = useState([]);
  const [totalPagesFisuras, setTotalPagesFisuras] = useState([]);
  const [confirmar, setConfirmar] = useState(true)
  const buttonRef = useRef(null);
  const clusterRef = useRef(null);
  const camposBusquedaSennal = ['tipo_especifico', 'tipo', 'carretera_asociada'];
  const camposBusqueda = ['severidad', 'tipo', 'area', 'frame']; // Incluye todos los campos que quieras buscar
  const [zoom, setZoom] = useState(1);
  const [translate, setTranslate] = useState({ x: 0, y: 0 })
  const [isPanning, setIsPanning] = useState(false)
  const [startPan, setStartPan] = useState({ x: 0, y: 0 })
  const imgRef = useRef(null)
  const containerRef = useRef(null)

  // Paginación
  const [visiblePages, setVisiblePages] = useState([1]); // Páginas visibles inicialmente
  const [visiblePagesFisuras, setVisiblePagesFisuras] = useState([1]); // Páginas visibles inicialmente
  const maxVisiblePages = 5; // Número máximo de páginas visibles a la vez
  const maxVisiblePagesFisuras = 5; // Número máximo de páginas visibles a la vez


  const lines = [
    "La busqueda es por el campo:",
    "frame",
  ];

  const position = [-34.6001622, -58.5846608]

  const [changedCoords, setChangedCoords] = useState({
    lat: -34.6001622,
    lng: -58.5846608,

  });

  const zoomIn = () => setZoom((z) => Math.min(z + 0.25, 3));
    const zoomOut = () => setZoom((z) => Math.max(z - 0.25, 0.5));
    const resetZoom = () => { setZoom(1); setTranslate({ x: 0, y: 0 }); }
  
    useEffect(() => {
      if (containerRef.current) containerRef.current.style.cursor = zoom > 1 ? 'grab' : 'default'
    }, [zoom])
  
    const clampTranslate = (x, y) => {
      const c = containerRef.current
      const img = imgRef.current
      if (!c || !img) return { x, y }
      const containerW = c.clientWidth
      const containerH = c.clientHeight
      const imgW = img.clientWidth // clientWidth ignores CSS transform scale
      const imgH = img.clientHeight
      const scaledW = imgW * zoom
      const scaledH = imgH * zoom
  
      let maxX = 0
      let maxY = 0
      if (scaledW > containerW) {
        maxX = (scaledW - containerW) / 2
      }
      if (scaledH > containerH) {
        maxY = (scaledH - containerH) / 2
      }
  
      const clampedX = Math.max(-maxX, Math.min(maxX, x))
      const clampedY = Math.max(-maxY, Math.min(maxY, y))
      return { x: clampedX, y: clampedY }
    }
  
    useEffect(() => {
      // Global listeners while panning so drag continues outside the container
      const onMouseMove = (e) => {
        if (!isPanning) return
        e.preventDefault()
        const desired = { x: e.clientX - startPan.x, y: e.clientY - startPan.y }
        const clamped = clampTranslate(desired.x, desired.y)
        setTranslate(clamped)
      }
      const onMouseUp = () => {
        if (!isPanning) return
        setIsPanning(false)
        if (containerRef.current) containerRef.current.style.cursor = 'grab'
      }
      const onTouchMove = (e) => {
        if (!isPanning) return
        e.preventDefault()
        const t = e.touches[0]
        const desired = { x: t.clientX - startPan.x, y: t.clientY - startPan.y }
        const clamped = clampTranslate(desired.x, desired.y)
        setTranslate(clamped)
      }
      const onTouchEnd = () => setIsPanning(false)
  
      if (isPanning) {
        document.addEventListener('mousemove', onMouseMove)
        document.addEventListener('mouseup', onMouseUp)
        document.addEventListener('touchmove', onTouchMove, { passive: false })
        document.addEventListener('touchend', onTouchEnd)
      }
      return () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
        document.removeEventListener('touchmove', onTouchMove)
        document.removeEventListener('touchend', onTouchEnd)
      }
    }, [isPanning, startPan])

  // 🔹 Función para agregar un pequeño desplazamiento aleatorio
  const getRandomOffset = () => (Math.random() - 0.5) * 0.0003;

  const handleMarkerClickWithCluster = (markerData1, e) => {
    handleMarkerClick(markerData1); // Ejecuta la función personalizada

    if (mapRef.current) {
      const map = mapRef.current;
      const zoom = map.getZoom();

      // 🔹 Si aún está agrupado, forzar zoom para separar los marcadores
      if (zoom < 17) {
        map.setZoom(17, { animate: true });
      }

      e.target.openPopup(); // 🔹 Abre el popup manualmente
    }
  };

  const handleCloseToast = (element) => {
    setShowSuccessToast(false);
    // navigate(`/detail-project/${id}`);
    window.location.href = `/detail-project/${id}`;
  }
  const handleCloseToastError = (element) => {
    setShowErrorToast(false);
  }

  const handleVerImagen = useCallback((url_frame) => {
    // console.log('valor: ', url_frame)
    setUrlFrame(url_frame);
    setVisible3(true);
  }, []);

  const handleMarkerClick = (markerData) => {
    // Actualiza el estado 'data' con la información del marcador
    // console.log("Clic en marcador:", markerData);
    setData([
      // { value: markerData.confianza, label: markerData.area, tipo: markerData.tipo, id_frame: markerData.id_frame },
      { tipo: markerData.tipo, tipo_especifico: markerData.tipo_especifico, id_frame: markerData.id_frame, url_frame: markerData.url_frame, tipo_camara: markerData.tipo_camara, name_video: markerData.name_video },
      // Puedes agregar más datos aquí si es necesario
    ]);
    // centerMapOnFirstMarkerClick(markerData.latitud, markerData.longitud)
  };

  const handleUpdateDanno = async () => {
    // e.preventDefault();
    // if (fechaRelevamiento != null) {
    //   fechaRelevamiento = selectedDate3.toISOString().slice(0, 19).replace('T', ' ');
    // }

    const formData = new FormData();
    formData.append('itemIdDano', itemIdDano);
    formData.append('area', area);
    formData.append('tipoDano', tipoDano);
    formData.append('tipoReclasificacionDano', severidadReclasificada);
    formData.append('severidad', severidad);
    formData.append('observaciones', observaciones);
    formData.append('latitudDano', latitudDano);
    formData.append('longitudDano', longitudDano);

    // formData.append('estadoDrenaje', CarreteraAsociadaDan);
    // formData.append('anchoCalzada', sentidoDano);


    // formData.append('estadoBordeCalzada', estadoBordeCalzada);
    // formData.append('tipoPavimento', tipoPavimento);

    try {
      const tokenData = localStorage.getItem('token'); // Obtiene el objeto JSON
      // console.log(storedName)
      const token = tokenData ? JSON.parse(tokenData).token : null; // Obtiene el token del objeto
      // console.log(token)
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/update/detection-damage`, formData, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        }
      });

      // console.log('Respuesta del servidor:', response.data);
      setVisible2(false);
      setShowSuccessToast(true);
      navigate(`/detail-project/${id}`);
      // setShowSuccessToast(true); 
      // navigate('/dashboard'); // Redirige si la data se obtiene correctamente
    } catch (error) {
      if (error.response.status === 401) {
        // Token inválido o expirado
        console.error("Error 401: No autorizado");
        // Redirige al inicio de sesión, limpia el token, etc.
        localStorage.removeItem('token');
        window.location.href = '/login'; // Ajusta la ruta si es necesario 
        console.error('Error al subir el video:', error);
      }
      setShowErrorToast(true)
    } finally {
      setIsLoading(false); // Ocultar el spinner al finalizar la carga
    }
  };

  const handleUpdateSennal = async () => {
    // e.preventDefault();
    // if (fechaRelevamiento != null) {
    //   fechaRelevamiento = selectedDate3.toISOString().slice(0, 19).replace('T', ' ');
    // }

    const formData = new FormData();
    formData.append('itemIdSenal', itemIdSenal);
    formData.append('tipoSenal', tipoSenal);
    formData.append('senaleticaDetectada', senaleticaDetectada);
    formData.append('senaleticaReclasificada', senaleticaReclasificada);
    formData.append('descripcionReclasificada', descripcionReclasificada);
    // formData.append('severidad', severidad);
    formData.append('observacionesSenal', observacionesSenal);
    formData.append('latitudSenal', latitudSenal);
    formData.append('longitudSenal', longitudSenal);

    try {
      const tokenData = localStorage.getItem('token'); // Obtiene el objeto JSON
      // console.log(storedName)
      const token = tokenData ? JSON.parse(tokenData).token : null; // Obtiene el token del objeto
      // console.log(token)
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/update/detection-sign`, formData, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        }
      });

      // console.log('Respuesta del servidor:', response.data);
      setVisible(false);
      setShowSuccessToast(true);
      navigate(`/detail-project/${id}`);
      // setShowSuccessToast(true); 
      // navigate('/dashboard'); // Redirige si la data se obtiene correctamente
    } catch (error) {
      if (error.response.status === 401) {
        // Token inválido o expirado
        console.error("Error 401: No autorizado");
        // Redirige al inicio de sesión, limpia el token, etc.
        localStorage.removeItem('token');
        window.location.href = '/login'; // Ajusta la ruta si es necesario 
        console.error('Error al subir el video:', error);
      }
      setShowErrorToast(true)
    } finally {
      setIsLoading(false); // Ocultar el spinner al finalizar la carga
    }
  };

  useEffect(() => {
    setActiveKey(1);
    setVisible(false)
    setVisible2(false)
    setConfirmar(true)
    if (confirmar && buttonRef.current) {
      // console.log(buttonRef.current)..
      buttonRef.current.focus(); // Asignar el foco al botón
    }
    // Este useEffect se ejecutará siempre que cambie `id` y asegurará que los datos se recarguen
  }, [id]);

  useEffect(() => {
    // console.log('jsonData')
    setActiveKey(1);
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // console.log('jsonData222')
        const tokenData = localStorage.getItem('token'); // Obtiene el objeto JSON
        const token = tokenData ? JSON.parse(tokenData).token : null; // Obtiene el token del objeto
        // console.log(token)
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/one-project/${id}`, {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        });
        // console.log('jsonData333')
        if (!response.ok) {
          if (response.status === 401) {
            // Token inválido o expirado
            console.error("Error 401: No autorizado");
            // Redirige al inicio de sesión, limpia el token, etc.
            localStorage.removeItem('token');
            window.location.href = '/login'; // Ajusta la ruta si es necesario 
          } else {
            // Otros errores
            throw new Error(`Error ${response.status}: ${response.statusText}`);
          }
        }
        // console.log('jsonData555')
        const jsonData = await response.json();
        setNameProyectoDetalles(jsonData[0].nombre);
        setData(jsonData);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }

    };
    fetchData();
  }, []);

  useEffect(() => {
    setActiveKey(1);
    if (dataProyecto) {
      console.log(dataProyecto)
      // console.log('Data proyecto nuevo:', dataProyecto.fisuras);
      // Carga información del proyecto
      setidProyecto(dataProyecto.proyecto[0].id);
      setNombreProyecto1(dataProyecto.proyecto[0].nombre);
      setCliente1(dataProyecto.proyecto[0].cliente)
      setOperador1(dataProyecto.proyecto[0].operador)
      setDescripcion1(dataProyecto.proyecto[0].descripcion)
      setFechaCreacion1(dataProyecto.proyecto[0].fecha_creacion);
      setFechaInicio1(dataProyecto.proyecto[0].fecha_inicio);
      setFechaFin1(dataProyecto.proyecto[0].fecha_fin);

      setDataProyecto(dataProyecto);
      // setCurrentItems(dataProyecto.senales.slice(currentPage, itemsPerPage))
      // setCurrentItemsFisuras(dataProyecto.fisuras.slice(currentPageFisuras, itemsPerPageFisuras))
      setCurrentItems(dataProyecto.result.results)
      setCurrentItemsFisuras(dataProyecto.result.results_2)
      setTotalPages(dataProyecto.result.pages)
      setTotalPagesFisuras(dataProyecto.result.pages_2)

    }

  }, [dataProyecto]);

  const centerMapOnFirstMarker = () => {
    // const dataProyecto2 = JSON.parse(localStorage.getItem('data-proyecto2'));
    const dataProyecto2 = dataProyecto

    setChangedCoords({
      lat: dataProyecto2.senales[0].latitud,
      lng: dataProyecto2.senales[0].longitud,
    });
    localStorage.removeItem('data-proyecto2');
  };

  const centerMapOnFirstMarkerClick = (latitud, longitud) => {
    setChangedCoords({
      lat: latitud,
      lng: longitud,
    });
  };

  // Actualizar currentItems cuando cambia currentPage
  useEffect(() => {
    if (dataProyecto) {
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      // setCurrentItems(dataProyecto.senales.slice(indexOfFirstItem, indexOfLastItem));
      // console.log(currentItems, '++')
    }
  }, [currentPage]);

  // Actualizar currentItems cuando cambia currentPage
  useEffect(() => {
    if (dataProyecto) {
      const indexOfLastItemFisuras = currentPageFisuras * itemsPerPageFisuras;
      const indexOfFirstItemFisuras = indexOfLastItemFisuras - itemsPerPageFisuras;
      // setCurrentItemsFisuras(dataProyecto.fisuras.slice(indexOfFirstItemFisuras, indexOfLastItemFisuras));
      // console.log(currentItemsFisuras)
    }
    // console.log(currentItemsFisuras, '--')
  }, [currentPageFisuras]);

  useEffect(() => {
    if (markersData) {
      // console.log('Data proyecto nuevo:', dataProyecto.fisuras);
      setMarkersData(markersData);

    }
  }, [markersData]);

  // useEffect(() => {
  //   if (mapRef.current) {
  //     mapRef.current.on("zoomend", () => {
  //       console.log("Zoom level:", mapRef.current.getZoom());
  //     });

  const handleEditDanno = (index, id) => {
    if (dataProyecto) {
      // console.log('index ', index)
      // console.log('id ', id)
      setItemIdDano(id); // Almacena el ID antes de abrir el modal
      setArea(dataResults2[index].area);
      setTipoDano(dataResults2[index].tipo);
      setSeveridad(dataResults2[index].severidad);
      setSeveridadReclasificada(dataResults2[index].tipo_reclasificacion)
      setObservaciones(dataResults2[index].descripcion);
      setLatitudDano(dataResults2[index].latitud);
      setLongitudDano(dataResults2[index].longitud);
      setLongitudDano(dataResults2[index].longitud);
      setCarreteraAsociadaDano(dataResults2[index].carretera_asociada);
      setSeveridadReclasificada(dataResults2[index].tipo_reclasificacion);
      setsentidoDano(dataResults2[index].sentido_carril);
      setfechaDeteccionDano(dataResults2[index].fecha_captura);
      // setPuntokmDano(dataProyecto.fisuras[index].puntokm);


      setVisible2(true);
    }
  };

  const handleEditSennal = (index, id) => {
    if (dataResults) {
      // console.log('index ', index)
      // console.log('id ', id)
      setItemIdSenal(id); // Almacena el ID antes de abrir el modal
      // setArea(dataProyecto.fisuras[index].area);
      setTipoSenal(dataResults[index].tipo);
      setSenaleticaDetectada(dataResults[index].tipo_especifico)
      setSenaleticaReclasificada(dataResults[index].tipo_reclasificacion)
      setSeveridad(dataResults[index].severidad);
      setObservacionesSenal(dataResults[index].descripcion);
      setDescripcionReclasificada(dataResults[index].descripcion_reclasificacion);
      setLatitudSenal(dataResults[index].latitud);
      setLongitudSenal(dataResults[index].longitud);
      // setSeveridadReclasificada(dataProyecto.fisuras[index].longitud);
      // setCarreteraAsociadaSenal(dataResults[index].name_video);
      setVideoAsociadoSenal(dataResults[index].name_video)
      setFechaDeteccionSenal(dataResults[index].fecha_captura);
      // setPuntokmSenal(dataProyecto.fisuras[index].puntokm);
      setSentidoSenal(dataResults[index].sentido_carril);
      setFrameData(dataResults[index].frame_data);
      

      setVisible(true);
    }
  };

  const handleDatosFrame = (index, id) => {
    if (dataResults) {
      // console.log('index ', index)
      console.log('id ', dataResults)
      setTipoPrincipal(dataResults[index].tipo_principal);
      setUbicacionEspecial(dataResults[index].ubicacion_especial);
      setEnCalzada(dataResults[index].en_calzada);
      setObstruccionCalzada(dataResults[index].obstruccion_calzada);
      setMonticuloTamano(dataResults[index].monticulo_tamano);
      setEstimacionBolsasCant(dataResults[index].estimacion_bolsas_cant);
      setBolsasRotasDispersion(dataResults[index].bolsas_rotas_dispersion);
      setAcumulacion(dataResults[index].acumulacion);
      setAnimalMuerto(dataResults[index].animal_muerto);
      setBolsas(dataResults[index].bolsas);
      setEscombro(dataResults[index].escombro);
      setNeumatico(dataResults[index].neumatico);
      setPoda(dataResults[index].poda);
      setVoluminoso(dataResults[index].voluminoso);
      setObservacionesjs(dataResults[index].observaciones);

      if (dataResults[index].tipo_especifico === 'arbol') {
        setVisibleDataFramePoda(true);
      } else {
        setVisibleDataFrame(true);
      }
      // fetchDataframe(id);

      
    }
  };

  const fetchDataframe = useCallback(async (frameId) => {
    setIsLoading(true);
    try {
      const tokenData = localStorage.getItem('token');
      const token = tokenData ? JSON.parse(tokenData).token : null;

      if (!token) {
        throw new Error('Token no disponible en localStorage');
      }

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/get-data-frame/${frameId}`, {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });

      if (response.status !== 200) {
        throw new Error("Error en la solicitud a la API");
      }
      console.log(response.data)
      console.log(response.data[0].frame_data)
      // setDataResults2(response.data.results_2)
      // setCurrentItemsFisuras(response.data.results_2)
      // setTotalPagesFisuras(response.data.pages_2)
      setFrameData(response.data[0].frame_data)




    } catch (error) {
      // Manejo de errores (como en el ejemplo anterior)
      if (error?.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      } else {
        setError(error?.message || "Error desconocido");
        console.error("Error al obtener los datos:", error);
      }
    } finally {
      setIsLoading(false);
    }
  }, [id]); // Dependencia de 'id'

  const handleDownload = () => {
    if (dataProyecto) {
      // Crea un objeto de hoja de cálculo para "Fisuras"
      // const worksheetFisuras = XLSX.utils.json_to_sheet(dataProyecto.fisuras);

      // Crea un objeto de hoja de cálculo para "Senales"
      const worksheetSenales = XLSX.utils.json_to_sheet(dataProyecto.senales);

      // Crea un libro de trabajo
      const workbook = XLSX.utils.book_new();

      // Agrega la hoja de cálculo de "Fisuras" al libro de trabajo
      // XLSX.utils.book_append_sheet(workbook, worksheetFisuras, 'Fisuras');

      // Agrega la hoja de cálculo de "Senales" al libro de trabajo
      XLSX.utils.book_append_sheet(workbook, worksheetSenales, 'Senales'); // Nombre de la pestaña

      // Crea un buffer de archivo
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      // Crea un enlace de descarga
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      downloadLink.download = 'data-proyecto.xlsx';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }

  };

  const handlefind = () => {
    setConfirmar(false)
    const fetchData = async () => {
      setIsLoading(true); // Muestra un indicador de carga mientras se realiza la solicitud

      try {
        const tokenData = localStorage.getItem('token'); // Obtén el token desde el localStorage
        const token = tokenData ? JSON.parse(tokenData).token : null; // Parsear el token JSON

        if (!token) {
          throw new Error('Token no disponible en localStorage'); // Manejar el caso en el que no haya token
        }

        // Realiza la solicitud a la API con el token en los headers
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/detail-project/${id}`, {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        });

        // Si la respuesta no es correcta, lanza un error
        if (!response.ok) {
          if (response.status === 401) {
            // Token inválido o expirado
            console.error("Error 401: No autorizado");
            // Redirige al inicio de sesión, limpia el token, etc.
            localStorage.removeItem('token');
            window.location.href = '/login'; // Ajusta la ruta si es necesario 
          } else {
            // Otros errores
            throw new Error(`Error ${response.status}: ${response.statusText}`);
          }
        }

        // Obtén los datos JSON de la respuesta
        const jsonData = await response.json();
        // console.log('Datos JSON recibidos:', jsonData); // Imprime los datos recibidos

        // Actualiza el estado de dataProyecto con los datos recibidos
        // console.log(jsonData);
        setDataProyecto(jsonData);
        setDataResults(jsonData.result.results)
        setDataResults2(jsonData.result.results_2)
        setMarkersData(jsonData);

        // Guarda los datos en el localStorage si es necesario
        localStorage.setItem('data-proyecto2', JSON.stringify(jsonData));

        // centerMapOnFirstMarker();
      } catch (error) {
        console.error('Error durante la solicitud:', error); // Manejo de errores
        setError(error); // Guarda el error en el estado para mostrarlo en la interfaz
      } finally {
        setIsLoading(false); // Detén el indicador de carga

      }
    };

    fetchData(); // Llama a la función fetchData cuando el componente se monte o cambie el id

  };

  // Función para descargar la imagen
  const handleDownloadImage = (imageUrl) => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = 'imagen_descargada.jpg'; // Puedes cambiar el nombre del archivo aquí
    link.click();
  };

  // Copiar dirección al portapapeles
  const handleCopyDireccion = (text, idx) => {
    if (!text) return;
    try {
      navigator.clipboard.writeText(text).then(() => {
        setCopiedRow(idx);
        setTimeout(() => setCopiedRow(null), 1500);
      }).catch((err) => {
        console.error('Error copiando al portapapeles:', err);
      });
    } catch (err) {
      console.error('Clipboard API no disponible:', err);
    }
  };

  // Abrir coordenadas en Google Maps
  const handleOpenInGoogleMaps = (lat, lng) => {
    if (!lat || !lng) return;
    // Construye la URL de Google Maps con lat,long
    const query = encodeURIComponent(`${lat},${lng}`);
    const url = `https://www.google.com/maps/search/?api=1&query=${query}`;
    try {
      window.open(url, '_blank');
    } catch (err) {
      console.error('No se pudo abrir Google Maps:', err);
    }
  };


  const fetchData2 = useCallback(async (pageSenales = 1, pageFisuras = 1, valor, claseSelect, searchIdFrame = '') => {
    setIsLoading(true);
    try {
      const tokenData = localStorage.getItem('token');
      const token = tokenData ? JSON.parse(tokenData).token : null;

      if (!token) {
        throw new Error('Token no disponible en localStorage');
      }

      // Añade el parámetro de búsqueda por id_frame si está presente
      const searchParam = searchIdFrame ? `&id_frame=${encodeURIComponent(searchIdFrame)}` : '';
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/results-new/${id}?page=${pageSenales}&per_page=${itemsPerPage}&claseSeleccionada=${claseSelect}${searchParam}`, {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });

      if (response.status !== 200) {
        throw new Error("Error en la solicitud a la API");
      }

      if (valor == 0) {
        setDataResults(response.data.results)
        setCurrentItems(response.data.results)
        setTotalPages(response.data.pages)

      }
      else {
        // console.log(response.data)
        setDataResults2(response.data.results_2)
        setCurrentItemsFisuras(response.data.results_2)
        setTotalPagesFisuras(response.data.pages_2)
      }



    } catch (error) {
      // Manejo de errores (como en el ejemplo anterior)
      if (error?.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      } else {
        setError(error?.message || "Error desconocido");
        console.error("Error al obtener los datos:", error);
      }
    } finally {
      setIsLoading(false);
    }
  }, [id]); // Dependencia de 'id'

  // Manejo de clic en la paginación para señales
  const handlePageClickSenales = (pageNumber) => {
    // console.log(pageNumber)
    // console.log('pageNumber')
    // console.log(dataResults)
    setCurrentPageSenales(pageNumber);
    // Vuelve a buscar datos con la nueva página; incluir la búsqueda actual (buscarTexto)
    fetchData2(pageNumber, currentPageSenales, 0, claseSeleccionada, buscarTexto);
    setCurrentPage(pageNumber);

    // Actualizar las páginas visibles
    const newVisiblePages = [pageNumber];
    for (let i = 1; i <= maxVisiblePages - 1; i++) {
      if (pageNumber - i > 0) {
        newVisiblePages.unshift(pageNumber - i);
      }
      if (pageNumber + i <= totalPages) {
        newVisiblePages.push(pageNumber + i);
      }
      if (newVisiblePages.length === maxVisiblePages) {
        break;
      }
    }
    setVisiblePages(newVisiblePages);
  };
  // Maneja clics en los cards superiores para filtrar el mapa y la tabla
  const handleCardFilter = (mapValue, claseValue) => {
    try {
      setMapFilter(mapValue);
      // Actualiza la clase seleccionada en el select
      setClaseSeleccionada(claseValue);
      // Reinicia la paginación de señales y solicita datos al servidor respetando la búsqueda actual
      setCurrentPageSenales(1);
      fetchData2(1, currentPageFisuras, 0, claseValue, buscarTexto);
    } catch (err) {
      console.error('Error en handleCardFilter:', err);
    }
  };
  // Manejo de clic en la paginación para fisuras
  const handlePageClickFisuras2 = (pageNumber) => {
    // console.log(pageNumber)
    // console.log('pageNumber2')
    setCurrentPageFisuras(pageNumber);
    // Vuelve a buscar datos con la nueva página; incluir la búsqueda actual (buscarTexto)
    fetchData2(pageNumber, currentPageFisuras, 1, claseSeleccionada, buscarTexto); // Vuelve a buscar datos con la nueva página

    setCurrentPageFisuras(pageNumber);

    // Actualizar las páginas visibles
    const newVisiblePagesFisuras = [pageNumber];
    for (let i = 1; i <= maxVisiblePagesFisuras - 1; i++) {
      if (pageNumber - i > 0) {
        newVisiblePagesFisuras.unshift(pageNumber - i);
      }
      if (pageNumber + i <= totalPagesFisuras) {
        newVisiblePagesFisuras.push(pageNumber + i);
      }
      if (newVisiblePagesFisuras.length === maxVisiblePagesFisuras) {
        break;
      }
    }
    setVisiblePagesFisuras(newVisiblePagesFisuras);
  };

  // Helper para renderizar paginación con el patrón: << 1 ... p-1 p p+1 ... N >>
  const renderPagination = (totalPagesCount, currentPageNumber, onPageClick) => {
    const total = parseInt(totalPagesCount, 10) || 0;
    const current = parseInt(currentPageNumber, 10) || 1;
    if (total <= 1) return null;

    const items = [];

    // Prev (<<)
    items.push(
      <CPaginationItem key="prev" disabled={current === 1} onClick={() => onPageClick(Math.max(1, current - 1))}>
        {'<'}
      </CPaginationItem>
    );

    // First page + left ellipsis
    if (current > 2) {
      items.push(
        <CPaginationItem key={1} active={1 === current} onClick={() => onPageClick(1)}>
          {1}
        </CPaginationItem>
      );
      if (current > 3) {
        items.push(
          <CPaginationItem key="start-ellipsis" disabled>
            ...
          </CPaginationItem>
        );
      }
    }

    // Pages around current: current-1, current, current+1
    const start = Math.max(1, current - 1);
    const end = Math.min(total, current + 1);
    for (let p = start; p <= end; p++) {
      items.push(
        <CPaginationItem key={p} active={p === current} onClick={() => onPageClick(p)}>
          {p}
        </CPaginationItem>
      );
    }

    // Right ellipsis + last page
    if (current < total - 1) {
      if (current < total - 2) {
        items.push(
          <CPaginationItem key="end-ellipsis" disabled>
            ...
          </CPaginationItem>
        );
      }
      items.push(
        <CPaginationItem key={total} active={total === current} onClick={() => onPageClick(total)}>
          {total}
        </CPaginationItem>
      );
    }

    // Next (>>)
    items.push(
      <CPaginationItem key="next" disabled={current === total} onClick={() => onPageClick(Math.min(total, current + 1))}>
        {'>'}
      </CPaginationItem>
    );

    return (
      <CPagination aria-label="Page navigation example" className="cursor-pointer">
        {items}
      </CPagination>
    );
  };

  return (
    <>
      <CRow className='margin-row-contenedor'>
        <CCol xs='12' className='d-flex align-items-center contenedor-table-list-titulo'>

          <CIcon icon={cilMap} size="xxl" className="height-auto icon-background-orange" style={{ '--ci-primary-color': 'white' }} /><h5 className='margin-bottom-h5'><strong>Detalle de Proyecto</strong></h5>
        </CCol>
        <div className="grid-container"> {/* Contenedor principal con CSS Grid */}
          <div className="grid-item map-container" style={{ position: 'relative' }}> {/* Primera cuadrícula superior para el mapa */}
            {/* <CCard className="mb-4"> */}
            <CCard>
              <div >
                <MapContainer
                  center={position}
                  zoom={13}
                  maxZoom={18}
                  style={{ height: "300px" }}
                  // zoomAnimation={true}
                  whenCreated={(mapInstance) => (mapRef.current = mapInstance)}
                >
                  {/* <MapContainer className="markercluster-map" center={position} zoom={13} scrollWheelZoom={true} style={{ height: '300px' }} zoomAnimation={true} ref={mapRef} whenCreated={(mapInstance) => (mapRef.current = mapInstance)}></MapContainer> */}
                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                  {/* Agrupación de marcadores */}
                  <MarkerClusterGroup ref={clusterRef} disableClusteringAtZoom={17}>
                    {(() => {
                      // Prepara el filtro de marcadores según la selección de cards
                      const senales = markersData && markersData.senales ? markersData.senales : [];
                      const filtered = senales.filter((m) => {
                        if (mapFilter === 'all') return true;
                        const tipo = (m.tipo || '').toString().toLowerCase();
                        const tipoEsp = (m.tipo_especifico || '').toString().toLowerCase();
                        // if (mapFilter === 'vertical') {
                        //   // intentar detectar señales verticales (heurística): no horizontales ni baches
                        //   if (/bache|baches/.test(tipoEsp)) return false;
                        //   if (/basur|residuos|residuo|basurero/.test(tipoEsp)) return false;
                        //   return /senal|señal|reglamentaria|preventiva|informativa|pictorama|pictoramas|poste|iluminacion|estructuras/.test(tipo) || /senal|señal/.test(tipoEsp) || tipoEsp.length > 0;
                        // }
                        if (mapFilter === 'arbol') {
                          // horizontales: mostrar solo marcadores relacionados con basura/residuos
                          // (buscar variantes: basur, residuos, basurero, residuo)
                          return /arbol|arboles|rbol|arbo/.test(tipoEsp) || /arbol|arboles|rbol|arbo/.test(tipo);
                        }
                        if (mapFilter === 'alumbrado') {
                          // horizontales: mostrar solo marcadores relacionados con basura/residuos
                          // (buscar variantes: basur, residuos, basurero, residuo)
                          return /alumbrado|luminaria|alumbrad|lumbrado/.test(tipoEsp) || /alumbrado|luminaria|alumbrad|lumbrado/.test(tipo);
                        }
                        if (mapFilter === 'semaforo') {
                          // horizontales: mostrar solo marcadores relacionados con basura/residuos
                          // (buscar variantes: basur, residuos, basurero, residuo)
                          return /semaforo|semafor|emaforo|foro/.test(tipoEsp) || /semaforo|semafor|emaforo|foro/.test(tipo);
                        }
                        if (mapFilter === 'basura') {
                          // horizontales: mostrar solo marcadores relacionados con basura/residuos
                          // (buscar variantes: basur, residuos, basurero, residuo)
                          return /basur|residuos|residuo|basurero/.test(tipoEsp) || /basur|residuos|residuo|basurero/.test(tipo);
                        }
                        if (mapFilter === 'baches') {
                          // baches/danos: buscar palabra bache o daño
                          return /bache|baches|dan(o|os)/.test(tipoEsp) || /bache|dan(o|os)/.test(tipo);
                        }
                        return true;
                      });

                      return filtered.map((markerData1) => (
                        <Marker
                          key={markerData1.id}
                          position={[
                            parseFloat(markerData1.latitud),
                            parseFloat(markerData1.longitud),
                          ]}
                          icon={getIcon(markerData1.tipo_especifico)}
                          eventHandlers={{
                            click: (e) => handleMarkerClickWithCluster(markerData1, e),
                          }}
                        >
                          <Popup>
                            <div>
                              <strong>Tipo:</strong> {markerData1.tipo}<br />
                              <strong>Especificación:</strong> {markerData1.tipo_especifico}<br />
                              <strong>Latitud:</strong> {markerData1.latitud}<br />
                              <strong>Longitud:</strong> {markerData1.longitud}<br />
                            </div>
                          </Popup>
                        </Marker>
                      ));
                    })()}
                  </MarkerClusterGroup>
                </MapContainer>
              </div>
            </CCard>
          </div>

          <CCard className='video-container-card'>

            <Widgets data={data} />

          </CCard>
        </div>
        {/* <CButton className="mt-2" onClick={handleUpdateMap}>Actualizar Posición</CButton> */}
        {/* <CButton className="mt-2" onClick={handleUpdatePosition}>Actualizar Posición</CButton> */}
        <div className="grid-container-4-cards">
          <div className="card-4-cards">
            <div className="grid-container-3-4-cards">
              <CRow>
                <CCol xs={2} className="letra-contenido padding-right-card-detail">
                  <CCard className='width-card-anotaciones' onClick={() => handleCardFilter('all', '')} style={{ cursor: 'pointer', border: mapFilter === 'all' ? '2px solid #f39c12' : undefined }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', padding: '12px', height: '100%' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img src={marketMapaSeñal} width={24} alt="Detección" />
                        <div className='letra-contenido-4' style={{ marginTop: '1px', textAlign: 'center' }}>Detección</div>
                      </div>
                      <div className='rsd2' style={{ marginTop: '1px', textAlign: 'center' }}>
                        <span className="letra-contenido-4">{dataProyecto && dataProyecto.fisuras && dataProyecto.senales ? dataProyecto.fisuras.length + dataProyecto.senales.length : 0}</span>
                        <span className='fuente-letra-gris ml-2'> /Totales</span>
                      </div>
                    </div>
                  </CCard>
                </CCol>
                <CCol xs={2} className="letra-contenido padding-right-card-detail">
                  <CCard className='width-card-anotaciones' onClick={() => handleCardFilter('arbol', 'arbol')} style={{ cursor: 'pointer', border: mapFilter === 'arbol' ? '2px solid #f39c12' : undefined }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', padding: '12px', height: '100%' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img src={marketArbol} width={24} alt="Árbol" />
                        <div className='letra-contenido-4' style={{ marginTop: '1px', textAlign: 'center' }}>Árbol</div>
                      </div>
                      <div className='rsd2' style={{ marginTop: '1px', textAlign: 'center' }}>
                        <span className="letra-contenido-4">{dataProyecto && dataProyecto.cantidad_senales ? dataProyecto.cantidad_senales[1].senales_arbol : 0}</span>
                        <span className='fuente-letra-gris ml-2'>/Totales</span>
                      </div>
                    </div>
                  </CCard>
                </CCol>
                <CCol xs={2} className="letra-contenido padding-right-card-detail">
                  <CCard className='width-card-anotaciones' onClick={() => handleCardFilter('alumbrado', 'alumbrado')} style={{ cursor: 'pointer', border: mapFilter === 'alumbrado' ? '2px solid #f39c12' : undefined }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', padding: '12px', height: '100%' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img src={marketAlumbrado} width={24} alt="Alumbrado" />
                        <div className='letra-contenido-4' style={{ marginTop: '1px', textAlign: 'center' }}>Alumbrado</div>
                      </div>
                      <div className='rsd2' style={{ marginTop: '1px', textAlign: 'center' }}>
                        <span className="letra-contenido-4">{dataProyecto && dataProyecto.cantidad_senales ? dataProyecto.cantidad_senales[0].senales_verticales : 0}</span>
                        <span className='fuente-letra-gris ml-2'>/Totales</span>
                      </div>
                    </div>
                  </CCard>
                </CCol>
                <CCol xs={2} className="letra-contenido padding-right-card-detail">
                  <CCard className='width-card-anotaciones' onClick={() => handleCardFilter('semaforo', 'semaforo')} style={{ cursor: 'pointer', border: mapFilter === 'semaforo' ? '2px solid #f39c12' : undefined }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', padding: '12px', height: '100%' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img src={marketSemaforo} width={24} alt="Semáforo" />
                        <div className='letra-contenido-4' style={{ marginTop: '1px', textAlign: 'center' }}>Semáforo</div>
                      </div>
                      <div className='rsd2' style={{ marginTop: '1px', textAlign: 'center' }}>
                        <span className="letra-contenido-4">{dataProyecto && dataProyecto.cantidad_senales ? dataProyecto.cantidad_senales[2].senales_semaforo : 0}</span>
                        <span className='fuente-letra-gris ml-2'>/Totales</span>
                      </div>
                    </div>
                  </CCard>
                </CCol>
                <CCol xs={2} className="letra-contenido padding-right-card-detail">
                  <CCard className='width-card-anotaciones' onClick={() => handleCardFilter('basura', 'basura')} style={{ cursor: 'pointer', border: mapFilter === 'basura' ? '2px solid #f39c12' : undefined }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', padding: '12px', height: '100%' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img src={marketBasura} width={24} alt="Basura" />
                        <div className='letra-contenido-4' style={{ marginTop: '1px', textAlign: 'center' }}>Basura</div>
                      </div>
                      <div className='rsd2' style={{ marginTop: '1px', textAlign: 'center' }}>
                        <span className="letra-contenido-4">{dataProyecto && dataProyecto.cantidad_senales ? dataProyecto.cantidad_senales[3].senales_horizontales : 0}</span>
                        <span className='fuente-letra-gris ml-2'>/Totales</span>
                      </div>
                    </div>
                  </CCard>
                </CCol>
                <CCol xs={2} className="letra-contenido padding-right-card-detail">
                  <CCard className='width-card-anotaciones' onClick={() => handleCardFilter('baches', 'bache')} style={{ cursor: 'pointer', border: mapFilter === 'baches' ? '2px solid #f39c12' : undefined }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', padding: '12px', height: '100%' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img src={marketBaches} width={24} alt="Baches" />
                        <div className='letra-contenido-4' style={{ marginTop: '1px', textAlign: 'center' }}>Baches</div>
                      </div>
                      <div className='rsd2' style={{ marginTop: '1px', textAlign: 'center' }}>
                        <span className="letra-contenido-4">{dataProyecto && dataProyecto.cantidad_senales ? dataProyecto.cantidad_senales[4].senales_baches : 0}</span>
                        <span className='fuente-letra-gris ml-2'>/Totales</span>
                      </div>
                    </div>
                  </CCard>
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
        <div className="grid-container-2"> {/* Contenedor principal con CSS Grid */}
          <div className="grid-item map-container"> {/* Primera cuadrícula superior para el mapa */}
            <CCard className='video-container-card'>
              <div class="tab-list-container">

                <div class="inner-addon right-addon">
                  <CRow>
                    <CCol xs='10'>
                      <CIcon icon={cilMagnifyingGlass} size="xxl" className="glyphicon glyphicon-search" style={{ '--ci-primary-color': 'black' }} />
                      {/* <input type="text" class="form-control" placeholder="Buscar proyecto" /> */}
                      {/* <CFormLabel htmlFor="anchoCarril"></CFormLabel> */}
                      <BuscadorSenales
                        searchInput={searchInput}
                        setSearchInput={setSearchInput}
                        buscarTexto={buscarTexto}
                        setBuscarTexto={setBuscarTexto}
                        claseSeleccionada={claseSeleccionada}
                        setClaseSeleccionada={setClaseSeleccionada}
                        fetchData2={fetchData2}
                        setCurrentPageSenales={setCurrentPageSenales}
                        currentPageFisuras={currentPageFisuras}
                        lines={lines}
                        Tooltip={Tooltip}
                        isLoading={isLoading}
                      />
                    </CCol>

                    <CCol xs='2'>
                      <div className='display-flex-icon'>
                        <CButton className="px-8 btn-descargar-list" type="submit" onClick={handleDownload}><img src={iconArrowDown} alt="Selected Image" className="mr-2" style={{ width: '11px', height: '11px', objectFit: 'contain' }} /><span className='padding-separar-boton-descargar'>Descargar</span></CButton>
                      </div>
                    </CCol>
                  </CRow>
                </div>
                <CTabs defaultActiveItemKey={1} activeKey={activeKey} onActiveKeyChange={setActiveKey}>
                  <CTabList variant="underline-border" className='tablist-map-component'>
                    <CTab className='asb asbd' aria-controls="home-tab-pane" itemKey={1}>Información de Proyecto</CTab>
                    <CTab className='asb' aria-controls="profile-tab-pane" itemKey={2}>Detecciones</CTab>
                    {/* <CTab className='asb' aria-controls="profile-tab-pane" itemKey={3}>Daños de Pavimento</CTab> */}
                  </CTabList>
                  <CTabContent>
                    <CTabPanel className="py-3 tabpanel-aling-content" aria-labelledby="home-tab-pane" itemKey={1}>
                      <CRow>
                        <CCol xs='6'>

                          <CCard className='video-container-card'>
                            <CRow>

                              <CCol xs='12'>
                                <CTable borderless className='margin-bottom-table'>
                                  <CTableBody>
                                    <CTableRow>
                                      <CTableDataCell className="quitar-padding-map letra-titulo-3">
                                        <h5>Proyecto ID {id}:</h5>
                                      </CTableDataCell>
                                    </CTableRow>
                                    <CTableRow>
                                      <CTableDataCell className="quitar-padding-map letra-titulo-3">
                                        {/* <strong>Relevamiento Autopista</strong> */}
                                        <strong>{nombreProyecto1}</strong>
                                      </CTableDataCell>
                                      <CTableDataCell className="quitar-padding-map letra-contenido">
                                        {/* 17/08/2024 15:02:56 */}
                                        {fechaCreacion1}
                                      </CTableDataCell>
                                    </CTableRow>
                                  </CTableBody>
                                </CTable>

                              </CCol>

                            </CRow>
                            <hr className='quitar-margin-hr'></hr>
                            <CRow>

                              <CCol xs='12'>

                                <CTable borderless className='margin-bottom-table'>
                                  <CTableBody>
                                    <CTableRow>
                                      <CTableDataCell className="quitar-padding-map letra-titulo-2">
                                        <strong>Fecha de inicio de ejecución:</strong>
                                      </CTableDataCell>
                                      <CTableDataCell className="quitar-padding-map letra-titulo-2">
                                        <strong>Fecha de fin de ejecución:</strong>
                                      </CTableDataCell>
                                    </CTableRow>
                                    <CTableRow>
                                      <CTableDataCell className="quitar-padding-map letra-contenido">
                                        {/* 17/08/2024 15:02:56 */}
                                        {fechaInicio1}
                                      </CTableDataCell>
                                      <CTableDataCell className="quitar-padding-map letra-contenido">
                                        {/* 17/08/2024 15:02:56 */}
                                        {fechaFin1}
                                      </CTableDataCell>
                                    </CTableRow>
                                  </CTableBody>
                                </CTable>

                              </CCol>

                              <CCol xs='12'>
                                <CTable borderless className='margin-bottom-table'>
                                  <CTableBody>
                                    <CTableRow>
                                      <CTableDataCell className="quitar-padding-with-2 letra-titulo-2">
                                        <strong>Cliente:</strong>
                                      </CTableDataCell>
                                      <CTableDataCell className="quitar-padding-map letra-titulo-2">
                                        {/* <strong>Operador:</strong> */}
                                        <strong>Operador:</strong>
                                      </CTableDataCell>

                                    </CTableRow>
                                    <CTableRow>
                                      <CTableDataCell className="quitar-padding-map letra-contenido">
                                        {/* Empresa XXD */}
                                        {cliente1}
                                      </CTableDataCell>
                                      <CTableDataCell className="quitar-padding-map letra-contenido">
                                        {operador1}
                                        {/* Juan Perez */}
                                      </CTableDataCell>

                                    </CTableRow>
                                  </CTableBody>
                                </CTable>
                              </CCol>
                              <CCol xs='12'>
                                <CTable borderless className='margin-bottom-table'>
                                  <CTableBody>
                                    <CTableRow>
                                      <CTableDataCell className="quitar-padding-map letra-titulo-2">
                                        <strong>Descripción:</strong>
                                      </CTableDataCell>

                                    </CTableRow>
                                    <CTableRow>
                                      <CTableDataCell className="quitar-padding-map letra-contenido">
                                        {/* Empresa XXD Empresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXDEmpresa XXD */}
                                        {descripcion1}
                                      </CTableDataCell>

                                    </CTableRow>
                                  </CTableBody>
                                </CTable>
                              </CCol>


                            </CRow>
                            <hr></hr>
                          </CCard>
                        </CCol>
                      </CRow>

                    </CTabPanel>
                    <CTabPanel className="py-3" aria-labelledby="profile-tab-pane" itemKey={2}>
                      <CCardBody className='contenedor-table-list container-tabla letra-contenido-2'>

                        <div className='contenedor-scroll-tabla-list' style={{ overflowy: 'auto', height: '370px' }}>
                          
                          <CTable striped small align="middle" className="mb-0 ctable-list" hover responsive style={{ width: '100%' }}>
                            <CTableHead className='letra-contenido-2 sticky-header-detail'>
                              <CTableRow>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>ID</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Tipo</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Latitud</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Longitud</CTableHeaderCell>
                                {/* <CTableHeaderCell className='letra-contenido-2 fgh'>Video asociado</CTableHeaderCell> */}
                                {/* <CTableHeaderCell className='letra-contenido-2 fgh'>Sentido</CTableHeaderCell> */}
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Frame</CTableHeaderCell>
                                {claseSeleccionada === 'basura' && (
                                  <CTableHeaderCell className='letra-contenido-2 fgh'>Principal</CTableHeaderCell>
                                )}
                                {claseSeleccionada === 'arbol' && (
                                  <CTableHeaderCell className='letra-contenido-2 fgh'>Poda</CTableHeaderCell>
                                )}
                                {/* <CTableHeaderCell className='letra-contenido-2 fgh'>Fecha detección</CTableHeaderCell> */}
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Dirección</CTableHeaderCell>
                                {/* <CTableHeaderCell className='letra-contenido-2 fgh'>Punto KM</CTableHeaderCell> */}
                                {/* <CTableHeaderCell className='letra-contenido-2 fgh'>Descripcíon</CTableHeaderCell> */}
                                <CTableHeaderCell ></CTableHeaderCell>

                              </CTableRow>
                            </CTableHead>
                            <CTableBody className='letra-contenido-3'>
                              {!isLoading && dataProyecto && dataProyecto.senales ? (

                                // Cuando se realiza búsqueda por id_frame, el servidor devuelve los resultados filtrados
                                // por tanto no es necesario filtrar de nuevo en el cliente. Mostramos los items tal cual.
                                currentItems.map((item, index) => (
                                  <CTableRow v-for="item in tableItems" key={index}>
                                    <CTableDataCell className="text-center">
                                      <div>{item.id}</div>
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      <div>{item.tipo_especifico}</div>
                                      <div className="small text-body-secondary text-nowrap">
                                        {/* <span>{item.user.new ? 'New' : 'Recurring'}</span> | Registered:{' '} */}
                                        {/* {item.user.registered} */}
                                      </div>
                                    </CTableDataCell>

                                    <CTableDataCell className="text-center">
                                      {/* <CIcon size="xl" icon={item.payment.icon} /> */}
                                      <div>{item.latitud}</div>
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {/* <div className="small text-body-secondary text-nowrap">Last login</div> */}
                                      {/* <div className="fw-semibold text-nowrap">{item.activity}</div> */}
                                      <div>{item.longitud}</div>
                                    </CTableDataCell>

                                    <CTableDataCell>
                                      <div><CAlertLink className="cursor-pointer" onClick={() => handleVerImagen(item.url_frame)}>
                                        {item.id_frame}
                                      </CAlertLink></div>
                                      {/* <div className="small text-body-secondary text-nowrap">Last login</div> */}
                                      {/* <div className="fw-semibold text-nowrap">{item.activity}</div> */}
                                    </CTableDataCell>

                                    {claseSeleccionada === 'basura' && (
                                      <CTableDataCell className="text-center">
                                        <div>{item.tipo_principal}</div>
                                      </CTableDataCell>
                                    )}
                                    {claseSeleccionada === 'arbol' && (
                                      <CTableDataCell className="text-center">
                                        <div>{item.poda == 1 ? 'si' : 'no'}</div>
                                      </CTableDataCell>
                                    )}
                                    {/* <CTableDataCell> */}
                                    {/* <div>{item.fecha_captura}</div> */}
                                    {/* <div className="small text-body-secondary text-nowrap">Last login</div> */}
                                    {/* <div className="fw-semibold text-nowrap">{item.activity}</div> */}
                                    {/* </CTableDataCell> */}

                                    <CTableDataCell className="text-center">
                                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                        <div style={{ maxWidth: '350px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.direccion}</div>
                                      </div>
                                    </CTableDataCell>
                                    {/* <CTableDataCell> */}
                                    {/* <div className="small text-body-secondary text-nowrap">Last login</div> */}
                                    {/* <div className="fw-semibold text-nowrap">{item.activity}</div> */}
                                    {/* </CTableDataCell> */}
                                    {/* <CTableDataCell> */}
                                    {/* <div className="d-flex justify-content-between text-nowrap"> */}
                                    {/* <div className="fw-semibold">{item.usage.value}%</div> */}
                                    {/* <div className="ms-3"> */}
                                    {/* <small className="text-body-secondary">{item.usage.period}</small> */}
                                    {/* </div>
                                      </div> */}
                                    {/* <CProgress thin color={item.usage.color} value={item.usage.value} /> */}
                                    {/* </CTableDataCell> */}
                                    <CTableDataCell className="text-center">
                                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                        {/* Botón de copiar trasladado aquí para agrupar los iconos */}
                                        <CButton
                                          size="sm"
                                          className="btn-copy"
                                          onClick={() => handleCopyDireccion(item.direccion || '', index)}
                                          title="Copiar dirección"
                                          style={{ width: '28px', height: '24px', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                          <img
                                            src={copiedRow === index ? copiadoImg : copiar}
                                            alt={copiedRow === index ? "Copiado" : "Copiar"}
                                            style={{ width: '14px', height: '14px' }}
                                          />
                                        </CButton>

                                        {/* Botón para abrir Google Maps (si existen coordenadas) */}
                                        {(item.latitud || item.longitud) && (
                                          <CButton
                                            size="sm"
                                            className="btn-open-map"
                                            onClick={() => handleOpenInGoogleMaps(item.latitud, item.longitud)}
                                            title="Abrir en Google Maps"
                                            style={{ width: '28px', height: '24px', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                          >
                                            <img src={locationIcon} alt="Abrir" style={{ width: '14px', height: '14px' }} />
                                          </CButton>
                                        )}

                                        <CButton
                                          size="sm"
                                          className="btn-copy"
                                          onClick={() => handleDatosFrame(index, item.id)}
                                          title="ver detalles"
                                          style={{ width: '28px', height: '24px', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                          <img
                                            src={dataFrame}
    
                                            style={{ width: '14px', height: '14px' }}
                                          />
                                        </CButton>

                                        {/* Dropdown con acciones (Editar, etc.) */}
                                        <CDropdown variant="btn-group">
                                          <CDropdownToggle className='dropdown-toggle-list btn-dropdown-list' color="white"><CIcon icon={cilOptions} style={{ '--ci-primary-color': 'black' }} /></CDropdownToggle>
                                          <CDropdownMenu className='dropdown-menu-list'>
                                            <CDropdownItem className="cursor-pointer" onClick={() => handleEditSennal(index, item.id)}>Editar</CDropdownItem>
                                            {/* {(item.latitud || item.longitud) && (
                                              <CDropdownItem className="cursor-pointer" onClick={() => handleOpenInGoogleMaps(item.latitud, item.longitud)}>
                                                Abrir en Google Maps
                                              </CDropdownItem>
                                            )} */}
                                          </CDropdownMenu>
                                        </CDropdown>
                                      </div>
                                    </CTableDataCell>
                                  </CTableRow>
                                ))

                              ) : (
                                <div>Cargando datos...</div> // Muestra un indicador de carga
                              )}
                            </CTableBody>
                          </CTable>
                        </div>

                        {/* </div> */}
                      </CCardBody>
                      {/* Paginación */}
                      {currentItems.length > 0 && (
                        <div className='center'>
                          {renderPagination(totalPages, currentPageSenales, handlePageClickSenales)}
                        </div>
                      )}
                      {/* Fin de la paginación */}
                    </CTabPanel>
                    <CTabPanel className="py-3" aria-labelledby="profile-tab-pane" itemKey={3}>
                      <CCardBody className='contenedor-table-list container-tabla letra-contenido-2'>

                        <div className='contenedor-scroll-tabla-list' style={{ overflowy: 'auto', height: '370px' }}>
                         
                          <CTable striped small align="middle" className="mb-0 ctable-list" hover responsive style={{ width: '100%' }}>
                            <CTableHead className='letra-contenido-2 sticky-header-detail'>
                              <CTableRow>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>ID</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Tipo</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Severidad</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Area</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Latitud</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Longitud</CTableHeaderCell>

                                <CTableHeaderCell className='letra-contenido-2 fgh'>Carretera asociada</CTableHeaderCell>

                                <CTableHeaderCell className='letra-contenido-2 fgh'>Sentido</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Frame</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Fecha detección</CTableHeaderCell>
                                <CTableHeaderCell className='letra-contenido-2 fgh'>Punto KM</CTableHeaderCell>
                                <CTableHeaderCell ></CTableHeaderCell>
                              </CTableRow>
                            </CTableHead>
                            <CTableBody className='letra-contenido-3'>
                              {dataProyecto && dataProyecto.result.results_2 ? (

                                currentItemsFisuras.map((item, index) => (

                                  // {/* {dataProyecto.fisuras.map((item, index) => ( */}
                                  <CTableRow v-for="item in tableItems" key={index}>
                                    <CTableDataCell className="text-center">
                                      <div>{item.id}</div>
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {/* <div>{item.tipo}</div> */}
                                      <div>{item.tipo}</div>
                                      <div className="small text-body-secondary text-nowrap">
                                        {/* <span>{item.user.new ? 'New' : 'Recurring'}</span> | Registered:{' '} */}
                                        {/* {item.user.registered} */}
                                      </div>
                                    </CTableDataCell>
                                    <CTableDataCell className="text-center">
                                      {/* <CIcon size="xl" icon={item.country.flag} title={item.country.name} /> */}
                                      <div>{item.severidad}</div>
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {/* <div className="d-flex justify-content-between text-nowrap"> */}
                                      {/* <div className="fw-semibold">{item.usage.value}%</div> */}
                                      <div>{item.area}</div>
                                      {/* </div> */}
                                      {/* <CProgress thin color={item.usage.color} value={item.usage.value} /> */}
                                    </CTableDataCell>
                                    <CTableDataCell className="text-center">
                                      {/* <CIcon size="xl" icon={item.payment.icon} /> */}
                                      <div>{item.latitud}</div>
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {/* <div className="small text-body-secondary text-nowrap">Last login</div> */}
                                      {/* <div className="fw-semibold text-nowrap">{item.activity}</div> */}
                                      <div>{item.longitud}</div>
                                    </CTableDataCell>

                                    <CTableDataCell>
                                      <div>{item.carretera_asociada}</div>
                                      {/* <div className="small text-body-secondary text-nowrap">Last login</div> */}
                                      {/* <div className="fw-semibold text-nowrap">{item.activity}</div> */}
                                    </CTableDataCell>

                                    <CTableDataCell>
                                      <div>{item.sentido_carril}</div>
                                      {/* <div className="small text-body-secondary text-nowrap">Last login</div> */}
                                      {/* <div className="fw-semibold text-nowrap">{item.activity}</div> */}

                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {/* <div className="small text-body-secondary text-nowrap">Last login</div> */}
                                      {/* <div className="fw-semibold text-nowrap">{item.activity}</div> */}
                                      <div><CAlertLink className="cursor-pointer" onClick={() => handleVerImagen(item.url_frame)}>
                                        {item.id_frame}
                                      </CAlertLink></div>
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      <div>{item.fecha_captura}</div>
                                      {/* <div className="small text-body-secondary text-nowrap">Last login</div> */}
                                      {/* <div className="fw-semibold text-nowrap">{item.activity}</div> */}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      {/* <div className="small text-body-secondary text-nowrap">Last login</div> */}
                                      {/* <div className="fw-semibold text-nowrap">{item.activity}</div> */}
                                    </CTableDataCell>
                                    <CTableDataCell>
                                      <CDropdown variant="btn-group">
                                        <CDropdownToggle className='dropdown-toggle-list btn-dropdown-list' color="white"><CIcon icon={cilOptions} style={{ '--ci-primary-color': 'black' }} /></CDropdownToggle>
                                        <CDropdownMenu className='dropdown-menu-list'>
                                          <CDropdownItem className="cursor-pointer" onClick={() => handleEditDanno(index, item.id)}>Editar</CDropdownItem>
                                        </CDropdownMenu>
                                      </CDropdown>
                                    </CTableDataCell>
                                  </CTableRow>
                                ))

                              ) : (
                                <div>Cargando datos...</div> // Muestra un indicador de carga
                              )}
                            </CTableBody>
                          </CTable>
                        </div>
                        {/* </div> */}
                      </CCardBody>
                      {/* Paginación */}
                      {currentItemsFisuras.length > 0 && (
                        <div className='center'>
                          {renderPagination(totalPagesFisuras, currentPageFisuras, handlePageClickFisuras2)}
                        </div>
                      )}
                      {/* Fin de la paginación */}
                    </CTabPanel>
                  </CTabContent>
                </CTabs>
              </div>
            </CCard>
          </div>
        </div>


      </CRow>
      <CModal
        alignment="center"
        scrollable
        visible={visible}
        onClose={() => setVisible(false)}
        aria-labelledby="VerticallyCenteredExample"

      >
        <CModalContent>
          <CModalHeader style={{ '--cui-modal-header-border-color': 'white' }}>
            <CModalTitle className='letra-titulo-modal' id="VerticallyCenteredExample">Edición de Señal</CModalTitle>
          </CModalHeader>
          <CModalBody>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={12}>
                  <CFormLabel htmlFor="tiposenal">Tipo</CFormLabel>
                  <CTooltip className='padding-tooltip'
                    content="Señalización Global (CLASS 1)"
                  // trigger={['hover', 'focus']}
                  >
                    <span className="d-inline-block padding-tooltip" tabIndex={0}>
                      <CButton className="btn-round-small">i</CButton>
                    </span>
                  </CTooltip>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="tiposenal" placeholder="Ingrese tipo" value={tipoSenal} onChange={(e) => setTipoSenal(e.target.value)} />
                </CCol>
              </CRow>
            </div>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={6}>
                  <CFormLabel htmlFor="senaleticadetectada">Señaletica Detectada</CFormLabel>
                  <CTooltip className='padding-tooltip'
                    content="Señalización Tipo (CLASS 2)"
                  // trigger={['hover', 'focus']}
                  >
                    <span className="d-inline-block padding-tooltip" tabIndex={0}>
                      <CButton className="btn-round-small">i</CButton>
                    </span>
                  </CTooltip>
                  <CFormInput className='letra-contenido-modal-input' size="sm" id="senaleticadetectada" placeholder="Ingrese señaletica" value={senaleticaDetectada} onChange={(e) => setSenaleticaDetectada(e.target.value)} />
                </CCol>
                {/* <CCol xs={6}>
                  <CFormSelect size="sm"
                    className='letra-contenido-modal-input'
                    label="Señaletica Reclasificada"
                    value={senaleticaReclasificada}
                    onChange={(e) => setSenaleticaReclasificada(e.target.value)}>
                    <option className='fuente-letra-oscura' >Seleccione</option>
                    <option className='fuente-letra-oscura' value="reglamentaria">Reglamentaria</option>
                    <option className='fuente-letra-oscura' value="preventiva">Prioritaria</option>
                    <option className='fuente-letra-oscura' value="informativa">Informativa</option>
                    <option className='fuente-letra-oscura' value="mojon_kilometrico">Mojón Kilométrico</option>
                    <option className='fuente-letra-oscura' value="poste_sos_emergencia_140">Poste SOS, Emergencia 140</option>
                    <option className='fuente-letra-oscura' value="estructuras">Estructuras</option>
                    <option className='fuente-letra-oscura' value="linea_de_carril">Linea de carril</option>
                    <option className='fuente-letra-oscura' value="linea_de_borde">Linea de Borde</option>
                    <option className='fuente-letra-oscura' value="flecha_simple_curvas_y_combinadas">Flecha Simple, Curvas y Combinadas</option>
                    <option className='fuente-letra-oscura' value="pictoramas">Pictoramas</option>
                    <option className='fuente-letra-oscura' value="defensas_metalicas_new_jersey">Defensas metálicas, New Jersey</option>
                    <option className='fuente-letra-oscura' value="iluminacion">Iluminación</option>
                    <option className='fuente-letra-oscura' value="baches">Baches</option>
                    <option className='fuente-letra-oscura' value="otra">Otra</option>
                  </CFormSelect>
                </CCol> */}
                {/* </CRow>
            </div>

            <div className="mb-3 letra-contenido-2">
              <CRow> */}
                <CCol xs={6}>
                  <CFormLabel htmlFor="descripciondetectada">Descripción Detectada</CFormLabel>
                  <CTooltip className='padding-tooltip'
                    content="Señalización Descripción (CLASS 5)"
                  // trigger={['hover', 'focus']}
                  >
                    <span className="d-inline-block padding-tooltip" tabIndex={0}>
                      <CButton className="btn-round-small">i</CButton>
                    </span>
                  </CTooltip>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="descripciondetectada" placeholder="Fuera de uso temporalmente" value={descripcionDetectada} onChange={(e) => setDescripcionDetectada(e.target.value)} />
                </CCol>
                {/* <CCol xs={6}>
                  <CFormSelect size="sm"
                    className='letra-contenido-modal-input'
                    label="Descripción Detectada Reclasificada"
                    value={descripcionReclasificada}
                    onChange={(e) => setDescripcionReclasificada(e.target.value)}>
                    <option className='fuente-letra-oscura' >Seleccione</option>
                    <option className='fuente-letra-oscura' value="no_avanzar">No avanzar</option>
                    <option className='fuente-letra-oscura' value="no_circular_automoviles">No circular Automóviles</option>
                    <option className='fuente-letra-oscura' value="prohibicion_de_cambiar_de_carril">Prohibición de cambiar de carril</option>
                    <option className='fuente-letra-oscura' value="velocidad_maxima_20">Velocidad maxima 20 km/h</option>
                  </CFormSelect>
                </CCol> */}
              </CRow>
            </div>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={12}>
                  <CFormLabel htmlFor="observacionessenal">Observaciones</CFormLabel>
                  <CFormTextarea
                    className='letra-contenido-modal-input'
                    id="observacionessenal"
                    placeholder="Escribe comentarios u observaciones"
                    value={observacionesSenal}
                    onChange={(e) => setObservacionesSenal(e.target.value)}
                    rows={4}
                  ></CFormTextarea>
                </CCol>


              </CRow>
            </div>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={6}>
                  <CFormLabel htmlFor="latitudsenal">Latitud</CFormLabel>
                  <CFormInput className='letra-contenido-modal-input' size="sm" id="latitudsenal" placeholder="Ingrese latitud" value={latitudSenal} onChange={(e) => setLatitudSenal(e.target.value)} />
                </CCol>
                <CCol xs={6}>
                  <CFormLabel htmlFor="longitudsenal">Longitud</CFormLabel>
                  <CFormInput className='letra-contenido-modal-input' size="sm" id="longitudsenal" placeholder="Ingrese longitud" value={longitudSenal} onChange={(e) => setLongitudSenal(e.target.value)} />
                </CCol>
              </CRow>
            </div>
            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={6}>
                  <CFormLabel htmlFor="videoAsociadoSenal">Video asociado</CFormLabel>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="videoAsociadoSenal" placeholder="Ingrese carretera" value={videoAsociadoSenal} onChange={(e) => setVideoAsociadoSenal(e.target.value)} />
                </CCol>
                <CCol xs={6}>
                  <CFormLabel htmlFor="fechadeteccionsenal">Fecha de detección</CFormLabel>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="fechadeteccionsenal" placeholder="Ingrese fecha" value={fechaDeteccionSenal} onChange={(e) => setFechaDeteccionSenal(e.target.value)} />
                </CCol>
              </CRow>
            </div>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={6}>
                  <CFormLabel htmlFor="puntokmsenal">Punto KM</CFormLabel>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="puntokmsenal" placeholder="Ingrese km" value={puntokmSenal} onChange={(e) => setPuntokmSenal(e.target.value)} />
                </CCol>
                <CCol xs={6}>
                  <CFormLabel htmlFor="sentidosenal">Sentido</CFormLabel>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="sentidosenal" placeholder="Ingrese sentido" value={sentidoSenal} onChange={(e) => setSentidoSenal(e.target.value)} />
                </CCol>
              </CRow>
            </div>

          </CModalBody>
          <CModalFooter style={{ '--cui-modal-footer-border-color': 'white' }}>
            <CButton className='btn-salir-footer' onClick={() => setVisible(false)}>
              Cancelar
            </CButton>
            <CButton className='btn-next-footer' onClick={() => handleUpdateSennal()}>Guardar</CButton>
          </CModalFooter>
        </CModalContent>
      </CModal>

      <CModal
        alignment="center"
        scrollable
        visible={visible2}
        onClose={() => setVisible2(false)}
        aria-labelledby="VerticallyCenteredExample"
      >
        <CModalContent >
          <CModalHeader style={{ '--cui-modal-header-border-color': 'white' }}>
            <CModalTitle className='letra-titulo-modal' id="VerticallyCenteredExample">Edición de Daño</CModalTitle>
          </CModalHeader>
          <CModalBody>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={6}>
                  <CFormLabel htmlFor="tipodano">Tipo</CFormLabel>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="tipodano" placeholder="Ingrese tipo" value={tipoDano} onChange={(e) => setTipoDano(e.target.value)} />
                </CCol>
                <CCol xs={6}>
                  <CFormLabel htmlFor="area">Area</CFormLabel>
                  <CFormInput className='letra-contenido-modal-input' size="sm" id="area" placeholder="Ingrese area" value={area} onChange={(e) => setArea(e.target.value)} />
                </CCol>
              </CRow>
            </div>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={6}>
                  <CFormLabel htmlFor="severidad">Severidad</CFormLabel>
                  <CFormInput className='letra-contenido-modal-input' size="sm" id="severidad" placeholder="Ingrese Severidad" value={severidad} onChange={(e) => setSeveridad(e.target.value)} />
                </CCol>
                <CCol xs={6}>
                  <CFormSelect size="sm"
                    className='letra-contenido-modal-input'
                    label="Severidad Reclasificada"
                    value={severidadReclasificada}
                    onChange={(e) => setSeveridadReclasificada(e.target.value)}>
                    <option className='fuente-letra-oscura' >Seleccione</option>
                    <option className='fuente-letra-oscura' value="T02">T2</option>
                    <option className='fuente-letra-oscura' value="T04">T4</option>
                    <option className='fuente-letra-oscura' value="T06">T6</option>
                    <option className='fuente-letra-oscura' value="T08">T8</option>
                    <option className='fuente-letra-oscura' value="T10">T10</option>
                  </CFormSelect>
                </CCol>
              </CRow>
            </div>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={12}>
                  <CFormLabel htmlFor="observacionesdano">Observaciones</CFormLabel>
                  <CFormTextarea
                    className='letra-contenido-modal-input'
                    id="observacionesdano"
                    placeholder="Escribe comentarios u observaciones"
                    value={observaciones}
                    onChange={(e) => setObservaciones(e.target.value)}
                    rows={4}
                  ></CFormTextarea>
                </CCol>


              </CRow>
            </div>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={6}>
                  <CFormLabel htmlFor="latituddano">Latitud</CFormLabel>
                  <CFormInput className='letra-contenido-modal-input' size="sm" id="latituddano" placeholder="Ingrese latitud" value={latitudDano} onChange={(e) => setLatitudDano(e.target.value)} />
                </CCol>
                <CCol xs={6}>
                  <CFormLabel htmlFor="longituddano">Longitud</CFormLabel>
                  <CFormInput className='letra-contenido-modal-input' size="sm" id="longituddano" placeholder="Ingrese longitud" value={longitudDano} onChange={(e) => setLongitudDano(e.target.value)} />
                </CCol>
              </CRow>
            </div>
            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={6}>
                  <CFormLabel htmlFor="carreteraasociadadano">Carretera asociada</CFormLabel>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="carreteraasociadadano" placeholder="Ingrese carretera" value={carreteraAsociadaDano} onChange={(e) => setCarreteraAsociadaDano(e.target.value)} />
                </CCol>
                <CCol xs={6}>
                  <CFormLabel htmlFor="fechadetecciondano">Fecha de detección</CFormLabel>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="fechadetecciondano" placeholder="Ingrese fecha" value={fechaDeteccionDano} onChange={(e) => setfechaDeteccionDano(e.target.value)} />
                </CCol>
              </CRow>
            </div>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={6}>
                  <CFormLabel htmlFor="puntokmDano">Punto KM</CFormLabel>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="puntokmDano" placeholder="Ingrese km" value={PuntokmDano} onChange={(e) => setPuntokmDano(e.target.value)} />
                </CCol>
                <CCol xs={6}>
                  <CFormLabel htmlFor="sentidoDano">Sentido</CFormLabel>
                  <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="sentidoDano" placeholder="Ingrese sentido" value={sentidoDano} onChange={(e) => setsentidoDano(e.target.value)} />
                </CCol>
              </CRow>
            </div>

          </CModalBody>
          <CModalFooter style={{ '--cui-modal-footer-border-color': 'white' }}>
            <CButton className='btn-salir-footer' onClick={() => setVisible2(false)}>Cancelar</CButton>
            <CButton className='btn-next-footer' onClick={() => handleUpdateDanno()}>Guardar</CButton>
          </CModalFooter>
        </CModalContent>
      </CModal>
      <CModal
        className=''
        alignment="center"
        visible={visible3}
        onClose={() => setVisible3(false)}
        aria-labelledby="VerticallyCenteredExample"
        size="lg"
      >
        <CModalBody className=''>
                  <CCard style={{ width: '48rem', height: '30 rem' }}>
                    <div style={{ position: 'relative' }}>
                      <div
                        ref={containerRef}
                        onMouseDown={(e) => {
                          if (zoom <= 1) return
                          e.preventDefault()
                          setIsPanning(true)
                          setStartPan({ x: e.clientX - translate.x, y: e.clientY - translate.y })
                          if (containerRef.current) containerRef.current.style.cursor = 'grabbing'
                        }}
                        onMouseLeave={() => { if (isPanning) setIsPanning(false) }}
                        onTouchStart={(e) => {
                          if (zoom <= 1) return
                          const t = e.touches[0]
                          setIsPanning(true)
                          setStartPan({ x: t.clientX - translate.x, y: t.clientY - translate.y })
                        }}
                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', width: '100%', touchAction: 'none' }}>
                        <img
                          ref={imgRef}
                          src={urlFrame}
                          alt="frame"
                          style={{
                            width: '100%',
                            maxWidth: '1000px',
                            height: 'auto',
                            transform: `translate(${translate.x}px, ${translate.y}px) scale(${zoom})`,
                            transition: isPanning ? 'none' : 'transform 150ms ease-in-out',
                            display: 'block',
                            cursor: zoom > 1 ? (isPanning ? 'grabbing' : 'grab') : 'default'
                          }}
                        />
                      </div>
                      <div style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', gap: '8px' }}>
                        {/* <CButton size="sm" color="light" onClick={zoomOut} title="Zoom out">-</CButton> */}
                        <CButton size="sm" color="light" onClick={resetZoom} title="Reset zoom">1x</CButton>
                        <CButton size="sm" color="light" onClick={zoomIn} title="Zoom in">+</CButton>
                      </div>
                      <button className='button-modal-frame' style={{ position: 'absolute', bottom: '10px', right: '40px' }}>
                        <CIcon icon={cilCloudDownload} title="Download file" style={{ '--ci-primary-color': 'white' }} 
                        onClick={() => handleDownload(data && data.length > 0 && data[0].url_frame ? data[0].url_frame : "https://3fpy.deepgaze.xyz/images/casita.jpg")} />
                      </button>
                      <button className='button-modal-frame' style={{ position: 'absolute', bottom: '10px', right: '10px' }}>
                        <CIcon icon={cilCompress} style={{ '--ci-primary-color': 'white' }} onClick={() => setVisible3(!visible3)} />
                      </button>
                    </div>
        
                  </CCard>
                </CModalBody>
      </CModal>

      <CModal
        alignment="center"
        visible={confirmar}
        onClose={() => setConfirmar(false)}
        aria-labelledby="VerticallyCenteredExample"
        size='sm'
      >
        <CModalContent>
          <CModalHeader style={{ '--cui-modal-header-border-color': 'white' }}>
            <CModalTitle className='letra-titulo-modal' id="VerticallyCenteredExample">Cargar Datos: Id. {id}</CModalTitle>
          </CModalHeader>
          <CModalBody className='letra-contenido-modal'>
            <center> <strong>Detalles del Proyecto: </strong><br></br> {nameProyectoDetalles}</center>
          </CModalBody>
          <CModalFooter style={{ '--cui-modal-footer-border-color': 'white', flexDirection: 'column' }}>
            {/* <CButton className='btn-salir-footer' onClick={() => setConfirmar(false)}>
              Cancelar
            </CButton> */}
            <div tabIndex="0" onClick={() => { setConfirmar(false) }}>
              <CButton className='btn-next-footer-model' ref={buttonRef} onClick={handlefind}>Aceptar</CButton>
            </div>
          </CModalFooter>
        </CModalContent>
      </CModal>

      <CModal
        alignment="center"
        scrollable
        visible={visibleDataFrame}
        onClose={() => setVisibleDataFrame(false)}
        aria-labelledby="VerticallyCenteredExample"

      >
        <CModalContent>
          <CModalHeader style={{ '--cui-modal-header-border-color': 'white' }}>
            <CModalTitle className='letra-titulo-modal' id="VerticallyCenteredExample">Datos Frame</CModalTitle>
          </CModalHeader>
          <CModalBody>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={12}>
                  <CFormLabel htmlFor="tiposenal">Información</CFormLabel>
                  {/* <pre>{JSON.stringify(frameData, null, 2)}</pre> */}
                   <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="tipoPrincipal">Tipo Principal</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="tipoPrincipal" placeholder="" value={tipoPrincipal} onChange={(e) => setTipoPrincipal(e.target.value)} />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="ubicacionEspecial">Ubicación Especial</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="ubicacionEspecial" placeholder="" value={ubicacionEspecial} onChange={(e) => setUbicacionEspecial(e.target.value)} />
                      </CCol>
                    </CRow>
                  </div>
                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="enCalzada">En Calzada</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="enCalzada" placeholder="" value={enCalzada} onChange={(e) => setEnCalzada(e.target.value)} />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="obstruccionCalzada">Obstrucción Calzada</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="obstruccionCalzada" placeholder="" value={obstruccionCalzada} onChange={(e) => setObstruccionCalzada(e.target.value)} />
                      </CCol>
                    </CRow>
                  </div>
                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="monticuloTamano">Monticulo Tamaño</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="monticuloTamano" placeholder="" value={monticuloTamano} onChange={(e) => setMonticuloTamano(e.target.value)} />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="estimacionBolsasCant">Estimación Bolsas Cantidad</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="estimacionBolsasCant" placeholder="" value={estimacionBolsasCant} onChange={(e) => setEstimacionBolsasCant(e.target.value)} />
                      </CCol>
                    </CRow>
                  </div>
                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="bolsasRotasDispersion">Bolsas Rotas Dispersión</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="bolsasRotasDispersion" placeholder="" value={bolsasRotasDispersion === 1 ? 'si' : 'no'} onChange={(e) => setBolsasRotasDispersion(e.target.value)} />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="acumulacion">Acumulación</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="acumulacion" placeholder="" value={acumulacion === 1 ? 'si' : 'no'} onChange={(e) => setAcumulacion(e.target.value)} />
                      </CCol>
                    </CRow>
                  </div>
                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="animalMuerto">Animal muerto</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="animalMuerto" placeholder="" value={animalMuerto === 1 ? 'si' : 'no'} onChange={(e) => setAnimalMuerto(e.target.value)} />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="bolsas">Bolsas</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="bolsas" placeholder="" value={bolsas === 1 ? 'si' : 'no'} onChange={(e) => setBolsas(e.target.value)} />
                      </CCol>
                    </CRow>
                  </div>
                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="escombro">Escombro</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="escombro" placeholder="" value={escombro === 1 ? 'si' : 'no'} onChange={(e) => setEscombro(e.target.value)} />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="neumatico">Neumatico</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="neumatico" placeholder="" value={neumatico === 1 ? 'si' : 'no'} onChange={(e) => setNeumatico(e.target.value)} />
                      </CCol>
                    </CRow>
                  </div>
                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="poda">Poda</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="poda" placeholder="" value={poda === 1 ? 'si' : 'no'} onChange={(e) => setPoda(e.target.value)} />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="voluminoso">Voluminoso</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="voluminoso" placeholder="" value={voluminoso === 1 ? 'si' : 'no'}  onChange={(e) => setVoluminoso(e.target.value)} />
                      </CCol>
                    </CRow>
                  </div>
                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={12}>
                        <CFormLabel htmlFor="observacionesjs">Observaciones</CFormLabel>
                        <CFormTextarea disabled className='letra-contenido-modal-input' size="lm" id="observacionesjs" placeholder="" value={observacionesjs} onChange={(e) => setObservacionesjs(e.target.value)} rows={8} >
                        
                        </CFormTextarea>
                      </CCol>
                    </CRow>
                  </div>
                  
                  
                </CCol>
              </CRow>
            </div>


          </CModalBody>
          <CModalFooter style={{ '--cui-modal-footer-border-color': 'white' }}>
            
          </CModalFooter>
        </CModalContent>
      </CModal>
      <CModal
        alignment="center"
        scrollable
        visible={visibleDataFramePoda}
        onClose={() => setVisibleDataFramePoda(false)}
        aria-labelledby="VerticallyCenteredExample"

      >
        <CModalContent>
          <CModalHeader style={{ '--cui-modal-header-border-color': 'white' }}>
            <CModalTitle className='letra-titulo-modal' id="VerticallyCenteredExample">Datos Frame</CModalTitle>
          </CModalHeader>
          <CModalBody>

            <div className="mb-3 letra-contenido-2">
              <CRow>
                <CCol xs={12}>
                  <CFormLabel htmlFor="tiposenal">Información</CFormLabel>
                  {/* <pre>{JSON.stringify(frameData, null, 2)}</pre> */}
                   <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="tipoPrincipal">Tipo Principal</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="tipoPrincipal" placeholder="" value={tipoPrincipal} onChange={(e) => setTipoPrincipal(e.target.value)} />
                      </CCol>
                      <CCol xs={6}>
                        <CFormLabel htmlFor="poda">Poda</CFormLabel>
                        <CFormInput disabled className='letra-contenido-modal-input' size="sm" id="poda" placeholder="" value={poda === 1 ? 'si' : 'no'} onChange={(e) => setPoda(e.target.value)} />
                      </CCol>
                    </CRow>
                  </div>
                  
                  <div className="mb-3 letra-contenido-2">
                    <CRow>
                      <CCol xs={12}>
                        <CFormLabel htmlFor="observacionesjs">Observaciones</CFormLabel>
                        <CFormTextarea disabled className='letra-contenido-modal-input' size="lm" id="observacionesjs" placeholder="" value={observacionesjs} onChange={(e) => setObservacionesjs(e.target.value)} rows={8} >
                        
                        </CFormTextarea>
                      </CCol>
                    </CRow>
                  </div>
                  
                  
                </CCol>
              </CRow>
            </div>


          </CModalBody>
          <CModalFooter style={{ '--cui-modal-footer-border-color': 'white' }}>
            
          </CModalFooter>
        </CModalContent>
      </CModal>
      {isLoading && ( // Mostrar el spinner solo si isLoading es true
        <div className="loading-overlay">
          <CSpinner color="primary" />
        </div>
      )}

      {showSuccessToast && (
        <CToast
          autohide={false}
          visible={true}
          // color="primary" 
          className="text-white align-items-center backgroundcolor-toast-exito"
          // Estilo para posicionar el toast
          style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 1000 }}
        >
          <div className="d-flex">
            <CToastBody>Registro insertado correctamente.</CToastBody>
            <CToastClose onClick={handleCloseToast} className="me-2 m-auto" white />
          </div>
        </CToast>
      )}

      {showErrorToast && (
        <CToast
          autohide={false}
          visible={true}
          // color="primary" 
          className="text-white align-items-center backgroundcolor-toast-error"
          // Estilo para posicionar el toast
          style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 1000 }}
        >
          <div className="d-flex">
            <CToastBody>Ha ocurrido un Error.</CToastBody>
            <CToastClose onClick={handleCloseToastError} className="me-2 m-auto" white />
          </div>
        </CToast>
      )}
    </>
  );
}

function Map() {
  const map = useMap();
  useMapEvents({
    click: (e) => {
      console.log('Click en:', e.latlng);
      map.panTo(e.latlng);
    }
  });
  return null;
}

